module.exports = __webpack_public_path__ + "img/i-go-back.9dfd461a.svg";